import React from 'react';

import styled from '@emotion/styled';

import {
  Accordion,
  AccordionCell,
} from '../../../components/Accordion/Accordion';
import CloseIcon from '../../../components/Icons/CloseIcon';
import {
  IPickListPackage,
  IPickListResponse,
} from '../../../models/pickList/pickList.model';
import { convertDate } from '../../../utils/utils';

interface IDipatcherPickList {
  data: IPickListResponse;
  onClickHandler: (...args: any[]) => void;
}

const DipatcherPickList: React.FC<IDipatcherPickList> = ({
  data,
  onClickHandler,
}) => {
  return (
    <>
      {data && (
        <Container>
          <SegmentWrapper>
            <HeaderSection>
              Pick List Details
              <IconWrapper onClick={onClickHandler}>
                <CloseIcon />
              </IconWrapper>
            </HeaderSection>
            <Summary>
              <SummaryHeader>
                {/* <div>
                  <div>Price</div>
                  <PickListId>#345678</PickListId>
                </div> */}

                <ActiveDiv>All Paid</ActiveDiv>
              </SummaryHeader>
              <PickListCount>{`${data.packages.length} items`}</PickListCount>
            </Summary>
          </SegmentWrapper>
          <Accordion>
            {data.packages.map((data: IPickListPackage, index) => (
              <AccordionCell title={`Package ${index + 1}`} key={index}>
                <DetailsSection>
                  <ContentRow>
                    <div>Receivers Name</div>
                    <div>{data.customerName}</div>
                  </ContentRow>
                  <ContentRow>
                    <div>Package ID</div>
                    <div>{data.airWayBillNumber}</div>
                  </ContentRow>
                  <ContentRow>
                    <div>Receiver’s Number</div>
                    <div>{data.customerPhoneNumber}</div>
                  </ContentRow>
                  <ContentRow>
                    <div>Receiver’s Address</div>
                    <div>{data.deliveryAddress}</div>
                  </ContentRow>
                  {/* <ContentRow>
                    <div>Checkout by:</div>
                    <div>{data['Checkout by']}</div>
                  </ContentRow>
                  <ContentRow>
                    <div>Confirmed by:</div>
                    <div>{data['Confirmed by']}</div>
                  </ContentRow> */}
                  <ContentRow>
                    <div>Delivery Date:</div>
                    <div>
                      {data.deliveryDate && convertDate(data.deliveryDate)}
                    </div>
                  </ContentRow>
                </DetailsSection>
              </AccordionCell>
            ))}
          </Accordion>
        </Container>
      )}
    </>
  );
};

export default DipatcherPickList;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  /* border: 2px solid red; */
  width: 100%;
`;

const SegmentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.19rem;
`;

const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* border: 2px solid yellow; */
  width: 100%;
  font-size: 1.125rem;
  font-weight: 500;
  color: #1f1f30;
`;

const DetailsSection = styled.div`
  font-size: 0.825rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const ContentRow = styled.div`
  display: flex;
  gap: 7rem;
  justify-content: space-between;
`;

const IconWrapper = styled.div`
  display: flex;
  cursor: pointer;
`;

const Summary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const SummaryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ActiveDiv = styled.div`
  color: #22b231;
  background-color: #ebf7ee;
  text-align: center;
  border-radius: 0.5rem;
  padding: 0.25rem 0.5rem;
  width: fit-content;
  height: fit-content;
  text-transform: capitalize;
  font-size: 0.875rem;
`;

// const PickListId = styled.div`
//   color: #1f2130;
//   font-weight: 700;
// `;

const PickListCount = styled.div`
  color: #1f2130;
  font-weight: 700;
`;
